// extracted by mini-css-extract-plugin
export default {"coloredDot":"ColoredDot_coloredDot__4pKIf","green":"ColoredDot_green__G6oTw","yellow":"ColoredDot_yellow__El7no","red":"ColoredDot_red__0VVPy","grey":"ColoredDot_grey__ZPc8K"};